import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles(theme => ({
  root: {
    border: `2px solid ${theme.palette.error.main}`,
    textAlign: "left",
    display: "inline-block",
    borderRadius: "20px",
    maxWidth: 400,
    paddingLeft: "20px",
    paddingRight: "20px",
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    marginBottom: 10,
    marginTop: 5,
    color: "#00003D",
  },
  body: {
    color: "#9A9A9A",
    fontSize: 16,
    marginBottom: 10,
  },
  subtitle: {
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 10,
    marginTop: 10,
  },

  date: {
    fontSize: 20,
    color: "#9A9A9A",
    fontWeight: 600,
  },

  numDays: {
    fontSize: 14,
    color: "rgba(154, 154, 154, 1)",
    textAlign: "right",
  },
}))

export default useStyles
